import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import PhoneIcon from '@mui/icons-material/Phone';
import Link from '@mui/material/Link';
import { COLORS } from '../theme/colors';

const phoneOutlineText = '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff';
const phoneOutlineIcon = 'drop-shadow(1px 1px 0 #fff) drop-shadow(-1px -1px 0 #fff) drop-shadow(1px -1px 0 #fff) drop-shadow(-1px 1px 0 #fff)';
const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    backgroundColor: theme.vars
        ? `rgba(${'#fff'} / 0.4)`
        : alpha('#fff', 0.4),
    boxShadow: (theme.vars || theme).shadows[1],
    padding: '8px 12px',
}));

export default function Header() {
    const handleScroll = (id) => {
        const target = document.getElementById(id);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <AppBar
            position="absolute"
            enableColorOnDark
            sx={{
                boxShadow: 0,
                bgcolor: 'transparent',
                backgroundImage: 'none',
                width: '100%'
            }}
        >

            <StyledToolbar>
                        <Box sx={(theme) => ({
                        display: 'flex', flexGrow: 1, 
                        borderRadius: {xs: `calc(${theme.shape.borderRadius}px + 8px)`, sm: 'none'},
                        backdropFilter: {xs:'blur(2px)', sm: 'none'},
                        border: {xs: '1px solid', sm: 'none'},
                 
                    })}>
                <Box sx={{ 
                    flexGrow: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    px: 0, 
                    paddingLeft: { xs: '0px', md: '48px', lg: '100px' }, 
                    gap: '8px', paddingRight: { xs: '0px', md: '48px', lg: '100px' }
                
                        }}>
                    <Box sx={{ flexGrow: 1,  gap: { xs: '2px', md: '16px' } }}>
                             <Button sx={{
                            borderRadius: '8px',
                            fontSize: { xs: '0.8rem', md: '1.1rem' },
                            color: COLORS.mutedText,
                            minWidth: 'auto',
                            padding: { xs: '6px 8px', md: '6px 8px' },
                            fontWeight:{ xs: 600, sm: '500' },
                            textShadow: { xs: phoneOutlineText, sm: 'none' },
                            '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            color: '#616161',
                            }
                        }}
                            onClick={() => handleScroll('about')}>
                            About
                        </Button>
                         <Button sx={{
                            borderRadius: '8px',
                            fontSize: { xs: '0.8rem', md: '1.1rem' },
                            color: COLORS.mutedText,
                            minWidth: 'auto',
                            padding: { xs: '6px 8px', md: '6px 8px' },
                            fontWeight:{ xs: 600, sm: '500' },
                            textShadow: { xs: phoneOutlineText, sm: 'none' },
                            '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            color: '#616161',
                            }
                        }}
                            onClick={() => handleScroll('services')}>
                            Services
                        </Button>
                        <Button sx={{
                            borderRadius: '8px',
                            fontSize: { xs: '0.8rem', md: '1.1rem' },
                            color: COLORS.mutedText,
                            minWidth: 'auto',
                            padding: { xs: '6px 8px', md: '6px 8px' },
                            fontWeight:{ xs: 600, sm: '500' },
                            textShadow: { xs: phoneOutlineText, sm: 'none' },
                            '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            color: '#616161',
                            }
                        }}
                            onClick={() => handleScroll('gallery')}>
                            Gallery
                        </Button>
                        </Box>
                    </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                        paddingRight: { xs: '16px', md: '48px', lg: '100px' }
                    }}
                >
                    <Link
                        href="tel:+17055004911"
                        underline="none"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            color: COLORS.mutedText,
                            fontWeight: 500,
                            textShadow: phoneOutlineText,
                            '&:hover': { color: '#616161' },
                        }}
                    >
                        <PhoneIcon fontSize="small" sx={{ filter: phoneOutlineIcon }} />
                        <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                            +1 (705) 500 4911
                        </Box>
                    </Link>
                </Box>
                </Box>
            </StyledToolbar>

        </AppBar>
    );
}
